import { render } from "./IconMinusOutlined.vue?vue&type=template&id=e5c68df0"
import script from "./IconMinusOutlined.vue?vue&type=script&lang=js"
export * from "./IconMinusOutlined.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/20/IconMinusOutlined.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5c68df0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5c68df0', __exports__)) {
    api.reload('e5c68df0', __exports__)
  }
  
  module.hot.accept("./IconMinusOutlined.vue?vue&type=template&id=e5c68df0", () => {
    api.rerender('e5c68df0', render)
  })

}


export default __exports__